/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiSaleBodyDataItemsItemSaleType =
    (typeof PostApiSaleBodyDataItemsItemSaleType)[keyof typeof PostApiSaleBodyDataItemsItemSaleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiSaleBodyDataItemsItemSaleType = {
    SALE: 'SALE',
    RETURN: 'RETURN',
} as const;
